<template>
  <div>
    <a-row :gutter="30">
      <a-col :span="24">
        <div class="siftArea">
          <a-input-search
            v-model="queryParam.name"
            placeholder="请输入学生名字"
            style="width: 170px; margin-right: 15px"
            @change="searchName"
          />
          <a-select
            v-model="queryParam.type"
            :options="typeOptions"
            style="width: 100px; margin-right: 15px"
          />
          <a-select
            v-model="queryParam.dateType"
            :options="dateRangeOptions"
            style="width: 100px; margin-right: 15px"
          />
          <a-range-picker :value="rangeDate" @change="onRangeChange" style="width: 250px" />
          <!-- <j-dict-select-tag
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            allowClear
            style="width: 170px"
          />
          <j-dict-select-tag
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
            style="width: 170px; margin-left: 10px"
          /> -->
          <a-button type="primary" style="margin-left: 15px" @click="tableQuery">查询</a-button>
          <a-button type="primary" style="margin-left: 10px" icon="download" @click="exportXls">
            导出
          </a-button>
        </div>
        <TableList
          :columns="schoolTableConfig.columns"
          :tableData="schoolTableConfig.tableData"
          :scroll="false"
          :loading="schoolTableConfig.loading"
          :pagination="schoolTableConfig.pagination"
          @change="handleTableChange"
        >
          <div slot="action" slot-scope="{ record }">
            <span class="action-detail" @click="signInClick(record)">签到</span>
            <a-divider type="vertical" />
            <span class="action-detail" @click="signOutClick(record)">签退</span>
          </div>
        </TableList>
      </a-col>
    </a-row>
    <StudentCounseModal ref="studentCounseRef" />
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import * as XLSX from 'xlsx'
import { simpleDebounce } from '@/utils/util'
import moment from 'moment'
import StudentCounseModal from '../StudentCounseModal'

const tabPagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'PsychologyReservation',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    StudentCounseModal,
  },
  data() {
    return {
      queryParam: {
        dateType: 1,
        type: 0,
      },
      rangeDate: [moment().subtract(7, 'days'), moment()],
      typeOptions: [
        { label: '全部类型', value: 0 },
        { label: '家长', value: 1 },
        { label: '老师', value: 2 },
      ],
      dateRangeOptions: [
        { label: '今天', value: 1 },
        { label: '近7天', value: 2 },
        { label: '近30天', value: 3 },
        { label: '近90天', value: 4 },
        { label: '近半年', value: 5 },
      ],
      gradeSelectItems: [],
      calssSelectItems: [],
      schoolTableConfig: {
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
          },
          {
            title: '年级',
            dataIndex: 'student_grade',
            align: 'center',
          },
          {
            title: '班级',
            dataIndex: 'student_class',
            align: 'center',
          },
          {
            title: '学生',
            dataIndex: 'warn',
            align: 'center',
          },
          {
            title: '发起时间',
            dataIndex: '',
            align: 'center',
          },
          {
            title: '预约人',
            dataIndex: '',
            align: 'center',
          },
          {
            title: '电话',
            dataIndex: '',
            align: 'center',
          },
          {
            title: '预约辅导时间',
            dataIndex: '',
            align: 'center',
          },
          {
            title: '备注信息',
            dataIndex: '',
            align: 'center',
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
        loading: false,
        pagination: { ...tabPagination },
      },
      url: {
        list: '/statistic/clientSchoolMood',
        classDetailsUrl: '/statistic/classDetails',
        exportXlsUrl: '/statistic/clientSchoolMood',
      },
      tabKey: 1,
      currRowInfo: {},
    }
  },
  created() {
    this.getSchoolMood()
  },
  methods: {
    exportXls() {
      const exportData = []
      this.schoolTableConfig.tableData.forEach((data) => {
        var singleData = {}
        this.schoolTableConfig.columns.forEach((column) => {
          if (column.title !== '操作' && column.dataIndex) {
            singleData[column.title] = data[column.dataIndex]
          }
        })
        exportData.push(singleData)
      })

      console.log('导出的数据格式：', exportData)

      // 将数据转化为xlsx的表格数据结构
      const ws = XLSX.utils.json_to_sheet(exportData)

      // 设置列宽
      ws['!cols'] = [
        { wpx: 40 }, // 第一列宽度为40像素
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ]

      // 开启自动换行并设置居中
      for (let cell in ws) {
        if (cell[0] === '!') continue // 跳过特殊属性
        if (!ws[cell].s) ws[cell].s = {} // 确保样式对象存在
        ws[cell].s.alignment = {
          wrapText: true, // 自动换行
          horizontal: 'center', // 水平居中
          vertical: 'center', // 垂直居中
        }
      }

      // 新建工作簿并添加表格数据
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '校园心情列表')

      // 生成Excel文件并导出
      XLSX.writeFile(wb, '校园心情列表.xlsx')
    },
    tableQuery() {
      console.log('查询--', this.queryParam)
      this.getSchoolMood()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
    }, 500),
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeDate = dates
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
    },
    handleTableChange(page) {
      this.$set(this.schoolTableConfig, 'pagination', page)
      this.getSchoolMood()
    },
    getSchoolMood() {
      this.$set(this.schoolTableConfig, 'loading', true)
      const params = {
        ...this.queryParam,
        pageNo: this.schoolTableConfig.pagination.current,
        pageSize: this.schoolTableConfig.pagination.pageSize,
      }
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          const tableData = res.result.records.length
            ? res.result.records.map((item, index) => ({
                index: index + 1,
                ...item,
              }))
            : []
          this.$set(this.schoolTableConfig, 'tableData', tableData)
          this.$set(this.schoolTableConfig.pagination, 'total', res.result.total)
          this.$set(this.schoolTableConfig, 'loading', false)
          console.log('tableData--', this.schoolTableConfig.tableData)
          console.log('pagination--', this.schoolTableConfig.pagination.total)
        }
      })
    },
    // 签到签退
    signInClick(record) {
      console.log('当前行数据--', record)
      this.$refs.studentCounseRef.show(record)
    },
    signOutClick(row) {
      console.log('当前行数据--', row)
      this.currRowInfo = row.record
    },
    handleTabChange(key) {
      this.tabKey = key
    },
    viewModal(data, type) {
      console.log('查看--', data)
      const studentInfo = { ...data.record, id: data.record.studentId }
      this.$refs.viewKeyPointModal.show(studentInfo, type)
    },
  },
}
</script>

<style scoped lang="less">
.siftArea {
  margin-left: 20px;
  margin-bottom: 20px;
}
.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;
}
::v-deep {
  .ant-tabs-nav-scroll {
    width: 100% !important;
    display: flex !important;
  }
  .ant-tabs-nav {
    display: flex !important;
    width: 100% !important;
  }
  .ant-tabs-ta {
    width: 33.33% !important;
  }
}
</style>
